module.exports = __webpack_public_path__ + "fonts/OpenSans700.29d492f6.eot";